module.exports = __webpack_public_path__ + "static/media/vending1.e95f81fc.jpeg";